import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isSaveTimeRecordRequestFailure(timeRecord) {
      const req = getState().find((req) => matchRequest(req, timeRecord));

      return req ? req.request.isFailure : false;
    },
    isSaveTimeRecordRequestPending(timeRecord) {
      const req = getState().find((req) => matchRequest(req, timeRecord));

      return req ? req.request.isPending : false;
    },
    isSaveTimeRecordRequestSuccess(timeRecord) {
      const req = getState().find((req) => matchRequest(req, timeRecord));

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
